<template>
  <div>
    <FreelancersMenu :menu="tab" :type="type"></FreelancersMenu><br />
    <CCard>
      <CCardHeader>
        <slot name="header">
          {{ tab == "available" ? "Visitas Disponibles" : (tab == "locked" ? "Visitas en Curso" : (tab == "completed" ? "Visitas por Validar" : (tab == "rejected" ? "Visitas Rechazadas" : (tab == "accepted" ? "Visitas por Pagar" : (tab == "paid" ? "Visitas Pagadas" : (tab == "limbo" ? "Visitas en el Limbo" : "Visitas Archivadas")))))) }}
          <div style="height: 10px;"></div>
          <div class="card-header-actions" style="width: 100%; margin-right: 5px;">
            <CRow>
              <CCol v-if="tab == 'locked'" :md="3" style="text-align: right;">
                <CSelect class="m-0"
                  :value.sync="dateSelect" 
                  :options="dateOptions"
                  @change="changeFilters"
                />  
              </CCol>
              <CCol v-if="tab != 'locked'" :md="3" style="text-align: right;">
                <CSelect class="m-0"
                  :value.sync="freelancerSelect" 
                  :options="freelancerOptions"
                  @change="changeFilters"
                  v-if="tab != 'available' && tab != 'limbo'"
                />  
              </CCol> 
              <CCol md="3" style="text-align: right;">
                <CSelect class="m-0"
                  :value.sync="weekSelect"
                  :options="weekOptions"
                  @change="changeFilters"
                />
              </CCol>
              <CCol :md="3" style="text-align: right;">
                <CSelect class="m-0"
                  :value.sync="customerSelect" 
                  :options="customerOptions"
                  @change="changeFilters"
                />  
              </CCol>                    
              <CCol :md="3" style="text-align: right;">
                <CSelect class="m-0"
                  :value.sync="regionSelect" 
                  :options="regionOptions"
                  @change="changeFilters"
                />  
              </CCol>
              <CCol md="2" style="text-align: right;" v-if="(tab == 'accepted' || tab == 'paid' || tab == 'completed' || tab == 'rejected') && (type == 'administrator' || type == 'superadmin')">
                <CButton color="info" size="sm" @click="payModal()" v-if="tab == 'accepted'">Pagar</CButton>
                <CButton color="success" size="sm" @click="exportVisits()" v-if="tab == 'accepted'">Exportar</CButton>
                <CButton color="success" size="sm" @click="exportVisits()" v-if="tab == 'paid'">Descargar Excel</CButton>
                <CButton color="success" size="sm" @click="exportCompletedAndRejectedVisits()" v-if="tab == 'completed' || tab == 'rejected'">Descargar Completadas + Rechazadas</CButton>
              </CCol>                           
            </CRow>
          </div>
        </slot>
      </CCardHeader>
      <CCardBody>
        <CRow>      
          <CCol md="12">
            <CDataTable 
              :hover="true"
              :striped="true"
              :border="true"
              :small="true"
              :fixed="true"
              :items="items"
              :fields="fields"
              :dark="false"
              style="width: 100%; font-size: 11px;"
            >           
              <template #id="{item}"><td class= "text-center w50">{{item.id}}</td></template>
              <template #freelancer="{item}">
                <td v-if="item.freelancer_id && item.freelancer_name" class= "text-center w200" style="text-transform: uppercase;"><b>{{item.freelancer_name}}</b><span v-if="tab == 'accepted' || tab == 'paid'"><br />{{item.freelancer_bank}}{{item.freelancer_bank == 'BBVA' ? ' - '+item.freelancer_account : ''}}<br />{{item.freelancer_clabe}}</span></td>
                <td v-if="!item.freelancer_id || !item.freelancer_name" class= "text-center w200">NO DEFINIDO</td>
              </template>
              <template #customer_name="{item}"><td class= "text-center w200">{{item.customer_name}}</td></template>
              <template #branch_name="{item}"><td class= "text-center w200">{{item.branch_name}}</td></template>
              <template #store_name="{item}"><td class= "text-center w200">{{item.store_name}}</td></template>        
              <template #date="{item}">
                <td class= "text-center w50">
                  {{item.date | date}}
                  <br v-if="canChangeVisitFields" />
                  <CButton color="info" size="sm" @click="changeDateModal(item)" v-if="canChangeVisitFields">Cambiar</CButton>
                </td>
              </template>
              <template #state="{item}"><td class= "text-center w200">{{item.state}}</td></template>
              <template #budget="{item}">
                <td class= "text-center w100">
                  {{item.budget | currency}}
                  <br v-if="canChangeVisitFields" />
                  <CButton color="info" size="sm" @click="changeBudgetModal(item)" v-if="canChangeVisitFields">Cambiar</CButton>
                </td>
              </template>
              <template #status="{item}"><td class= "text-center w100">{{item.status == 'AVAILABLE' ? 'DISPONIBLE' : (item.status == 'LOCKED' ? 'EN CURSO' : (item.status == 'COMPLETED' ? 'POR VALIDAR' : (item.status == 'ACCEPTED' ? 'POR PAGAR' : (item.status == 'REJECTED' ? 'RECHAZADA' : (item.status == 'PAID' ? 'PAGADA' : "ARCHIVADA")))))}}</td></template>
              <template #actions="{item}">
                <td :class="'table_actions '+(item.status == 'COMPLETED' || item.status == 'LOCKED' ? 'b3' : 'b2')">
                  <template v-if="tab == 'limbo'">
                    <CButton color="danger" size="sm" @click="assignFreelancerModal(item)" v-if="!item.freelancer_id">Reasignar</CButton>
                    <CButton color="warning" size="sm" @click="rectifyVisitModal(item)" v-if="item.freelancer_id">Rectificar</CButton>
                  </template>
                  <template v-else>
                    <CButton color="info" size="sm" @click="block(item)" v-if="item.status == 'AVAILABLE'">Bloquear</CButton>
                    <CButton color="warning" size="sm" @click="unblock(item)" v-if="item.status == 'LOCKED'">Liberar</CButton>
                    <CButton color="success" size="sm" @click="complete(item)" v-if="item.status == 'LOCKED'">Terminar</CButton>
                    <CButton color="danger" size="sm" @click="deleteVisit(item)" v-if="item.status == 'AVAILABLE' || item.status == 'LOCKED'">Eliminar</CButton>
                    <CButton color="warning" size="sm" @click="releaseRejectedModal(item)" v-if="item.status == 'REJECTED'">Liberar</CButton>
                    <CButton color="success" size="sm" @click="reactive(item)" v-if="item.status == 'REJECTED'">Reactivar</CButton>
                    <CButton color="info" size="sm" @click="archive(item)" v-if="item.status == 'PAID'">Archivar</CButton>
                  </template>
                  
                  <CButton color="info" size="sm" @click="showVisitModal(item)" v-if="tab == 'limbo' || item.status != 'AVAILABLE'">Ver Visita</CButton>
                  <br v-if="tab != 'limbo' && (item.status == 'COMPLETED' || item.status == 'ACCEPTED') && (type == 'kam' || type == 'support' || type == 'superadmin' || type == 'administrator')" />
                  <CButton color="success" size="sm" @click="validateModal(item)" v-if="tab != 'limbo' && item.status == 'COMPLETED' && (type == 'kam' || type == 'support' || type == 'superadmin')">Aprobar</CButton>
                  <CButton color="danger" size="sm" @click="rejectModal(item)" v-if="tab != 'limbo' && ((item.status == 'COMPLETED' && (type == 'kam' || type == 'support' || type == 'superadmin')) || (item.status == 'ACCEPTED' && (type == 'kam' || type == 'support' || type == 'superadmin' || type == 'administrator')))">Rechazar</CButton>
                </td>
              </template>
            </CDataTable>
            <ul class="pagination justify-content-start" style="font-size: 10px;">

              <!-- First -->
              <li class="page-item" :class="{ disabled: pagination.current === 1 }">
                <a class="page-link" href="#" @click.prevent="changeFilters(1)">«</a>
              </li>

              <!-- Prev -->
              <li class="page-item" :class="{ disabled: !pagination.prev }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(pagination.current - 1)">‹</a>
              </li>

              <!-- Pages -->
              <li v-for="page in pages"
                  :key="page"
                  class="page-item"
                  :class="{ active: page === pagination.current }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(page)">
                  {{ page }}
                </a>
              </li>

              <!-- Next -->
              <li class="page-item" :class="{ disabled: !pagination.next }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(pagination.current + 1)">›</a>
              </li>

              <!-- Last -->
              <li class="page-item" :class="{ disabled: pagination.current === pagination.last }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(pagination.last)">»</a>
              </li>

            </ul>
            <span style="float: right; font-weight: bold;" v-if="tab == 'accepted'">Total a Pagar: {{ total | currency }}</span>
          </CCol>    
        </CRow>
      </CCardBody>
    </CCard>

    <VisitValidationModal ref="visitValidationModal" @refresh="refreshItems"></VisitValidationModal>
    <RejectValidationModal ref="visitRejectModal" @refresh="refreshItems"></RejectValidationModal>
    <ShowVisitModal ref="visitShowModal"></ShowVisitModal>
    <ChangeVisitDateModal ref="changeVisitDateModal" @refresh="refreshItems"></ChangeVisitDateModal>
    <ChangeVisitBudgetModal ref="changeVisitBudgetModal" @refresh="refreshItems"></ChangeVisitBudgetModal>
    <PaymentVisitsModal ref="paymentVisitsModal" @refresh="refreshItems"></PaymentVisitsModal>
    <ReleaseRejectedVisitModal ref="releaseRejectedVisitModal" @refresh="refreshItems"></ReleaseRejectedVisitModal>

    <CModal :show.sync="showAssignFreelancerModal" color="danger">
      <template #header>
        <CRow style="width: 100%; height: 5px;">
          <CCol md="9">Reasignar Promotor</CCol>
          <CCol md="3"></CCol>
        </CRow>
        <CButtonClose @click="closeAssignFreelancerModal" />
      </template>

      <CRow>
        <CCol md="12">
          <CSelect
            :value.sync="assignFreelancerId"
            :options="assignableFreelancerOptions"
            label="Promotor"
          />
        </CCol>
      </CRow>

      <template #footer>
        <CButton @click="closeAssignFreelancerModal" color="secondary">Cancelar</CButton>
        <CButton @click="confirmAssignFreelancer" color="info">Asignar</CButton>
      </template>
    </CModal>

    <CModal :show.sync="showRectifyStatusModal" color="warning">
      <template #header>
        <CRow style="width: 100%; height: 5px;">
          <CCol md="9">Rectificar Status</CCol>
          <CCol md="3"></CCol>
        </CRow>
        <CButtonClose @click="closeRectifyStatusModal" />
      </template>

      <CRow>
        <CCol md="12">
          <CSelect
            :value.sync="rectifyStatus"
            :options="rectifyStatusOptions"
            label="Nuevo status"
          />
        </CCol>
      </CRow>

      <template #footer>
        <CButton @click="closeRectifyStatusModal" color="secondary">Cancelar</CButton>
        <CButton @click="confirmRectifyStatus" color="warning">Rectificar</CButton>
      </template>
    </CModal>

    <CModal :show.sync="showExportProgressModal" color="info" :closeOnBackdrop="false" :centered="true">
      <template #header>
        <CRow style="width: 100%; height: 5px;">
          <CCol md="12">Progreso de descarga</CCol>
        </CRow>
      </template>

      <CRow>
        <CCol md="12">
          <p style="margin-bottom: 8px;"><b>{{ exportProgressTitle }}</b></p>
          <p style="margin-bottom: 8px;">{{ exportProgressDetail }}</p>
          <p style="margin-bottom: 0;">{{ exportProgressPercent }}%</p>
        </CCol>
      </CRow>
    </CModal>
  </div>
</template>
<script>

import store from '../../store'
import ws from '../../services/freelancers';
import FreelancersMenu from './FreelancersMenu.vue';
import VisitValidationModal from '../../components/freelancers/VisitValidationModal.vue';
import RejectValidationModal from '../../components/freelancers/RejectValidationModal.vue';
import ShowVisitModal from '../../components/freelancers/ShowVisitModal.vue';
import ChangeVisitDateModal from '../../components/freelancers/ChangeVisitDateModal.vue';
import ChangeVisitBudgetModal from '../../components/freelancers/ChangeVisitBudgetModal.vue';
import PaymentVisitsModal from '../../components/freelancers/PaymentVisitsModal.vue';
import ReleaseRejectedVisitModal from '../../components/freelancers/ReleaseRejectedVisitModal.vue';
import freelancers from '../../services/freelancers';

export default {
  name: 'FreelanceVisits',
  components: {
    FreelancersMenu,
    VisitValidationModal,
    RejectValidationModal,
    ShowVisitModal,
    ChangeVisitDateModal,
    ChangeVisitBudgetModal,
    PaymentVisitsModal,
    ReleaseRejectedVisitModal
  },
  data () {
    return {
      tab: 'available',
      items: [],
      total: 0,
      fields: [
          {key: 'id', label: 'No.', _style:" font-size: 12px;"},
          {key: 'date', label: 'Dia de Visita', _style:" font-size: 12px;"},
          {key: 'customer_name', label: 'Marca', _style:" font-size: 12px;"},          
          {key: 'store_name', label: 'Cadena', _style:" font-size: 12px;"},
          {key: 'branch_name', label: 'Sucursal', _style:" font-size: 12px;"},
          {key: 'state', label: 'Zona', _style:" font-size: 12px;"},
          {key: 'budget', label: 'Monto a Pagar', _style:" font-size: 12px;"},
          {key: 'freelancer', label: 'Promotor', _style:" font-size: 12px;"},
          {key: 'status', label: 'Status', _style:" font-size: 12px;"},
          {key: 'actions', label: 'Acciones', _style:" font-size: 12px;"},
      ],
      customerSelect: "",
      customersOptions: [],
      kamSelect: "",
      kamsOptions: [],
      monthSelect: "202409",
      monthsOptions: [],
      customerSelect: "TODAS",
      customers: [],
      customerOptions: [],
      freelancerSelect: "TODOS",
      freelancers: [],
      freelancerOptions: [],
      regionSelect: "TODAS",
      regionOptions: [
        {value: 'TODAS', label: 'TODAS LAS ZONAS'}, 
        {value: 'AGUASCALIENTES', label: 'AGUASCALIENTES'}, 
        {value: 'BAJA CALIFORNIA NORTE', label: 'BAJA CALIFORNIA NORTE'}, 
        {value: 'BAJA CALIFORNIA SUR', label: 'BAJA CALIFORNIA SUR'}, 
        {value: 'CAMPECHE', label: 'CAMPECHE'}, 
        {value: 'CHIAPAS', label: 'CHIAPAS'}, 
        {value: 'CHIHUAHUA', label: 'CHIHUAHUA'}, 
        {value: 'COAHUILA', label: 'COAHUILA'}, 
        {value: 'COLIMA', label: 'COLIMA'}, 
        {value: 'DURANGO', label: 'DURANGO'}, 
        {value: 'GUANAJUATO', label: 'GUANAJUATO'}, 
        {value: 'GUERRERO', label: 'GUERRERO'}, 
        {value: 'HIDALGO', label: 'HIDALGO'}, 
        {value: 'JALISCO', label: 'JALISCO'}, 
        {value: 'MEXICO', label: 'MÉXICO'}, 
        {value: 'MICHOACAN', label: 'MICHOACÁN'}, 
        {value: 'MORELOS', label: 'MORELOS'}, 
        {value: 'NUEVO LEON', label: 'NUEVO LEÓN'}, 
        {value: 'NAYARIT', label: 'NAYARIT'}, 
        {value: 'OAXACA', label: 'OAXACA'}, 
        {value: 'PUEBLA', label: 'PUEBLA'}, 
        {value: 'QUERETARO', label: 'QUERÉTARO'}, 
        {value: 'QUINTANA ROO', label: 'QUINTANA ROO'}, 
        {value: 'SAN LUIS POTOSI', label: 'SAN LUIS POTOSÍ'}, 
        {value: 'SINALOA', label: 'SINALOA'}, 
        {value: 'SONORA', label: 'SONORA'}, 
        {value: 'TABASCO', label: 'TABASCO'}, 
        {value: 'TAMAULIPAS', label: 'TAMAULIPAS'}, 
        {value: 'TLAXCALA', label: 'TLAXCALA'}, 
        {value: 'VERACRUZ', label: 'VERACRUZ'}, 
        {value: 'YUCATAN', label: 'YUCATÁN'}, 
        {value: 'ZACATECAS', label: 'ZACATECAS'}
      ],
      dateSelect: "ACTUALES",
      dateOptions: [
        {value: 'CURRENT', label: 'VISITAS ACTUALES'}, 
        {value: 'ARCHIVED', label: 'VISITAS PASADAS'}
      ],
      weekSelect: "",
      weekOptions: [],
      pagination: {
        current: 1,
        last: 1,
        perPage: 0,
        total: 0,
        next: null,
        prev: null
      },
      type: '',
      showAssignFreelancerModal: false,
      selectedVisitToAssign: null,
      assignFreelancerId: '',
      showRectifyStatusModal: false,
      selectedVisitToRectify: null,
      rectifyStatus: '',
      showExportProgressModal: false,
      exportProgressTitle: '',
      exportProgressDetail: '',
      exportProgressPercent: 0
    }
  },
  mounted: async function() {
    this.initializeWeekOptions();

    this.tab = await this.$route.params.tab;

    await this.changeFilters(1);

    let is_superadmin = localStorage.getItem("is_superadmin");
    let is_administrator = localStorage.getItem("is_administrator");
    let is_kam = localStorage.getItem("is_kam");
    let is_support = localStorage.getItem("is_support");

    if(is_superadmin == "true"){
      this.type = "superadmin"
    }
    else if(is_administrator == "true"){
      this.type = "administrator"
    }
    else{
      if(is_kam == "true"){
        this.type = "kam"
      }
      else if(is_support == "true"){
        this.type = "support"
      }
    }
  },
  computed: {
    canChangeVisitFields() {
      return this.type == 'administrator' && (this.tab == 'available' || this.tab == 'locked');
    },
    pages() {
      let start = Math.max(this.pagination.current - 2, 1)
      let end = Math.min(start + 4, this.pagination.last)

      return Array.from(
        { length: end - start + 1 },
        (_, i) => start + i
      )
    },
    assignableFreelancerOptions() {
      const options = [{ value: '', label: 'SELECCIONA UN PROMOTOR' }]

      if(this.freelancerOptions && this.freelancerOptions.length > 0){
        return options.concat(this.freelancerOptions.filter(option => String(option.value) != 'TODOS'))
      }

      return options
    },
    rectifyStatusOptions() {
      return [
        { value: 'AVAILABLE', label: 'LIBERAR VISITA' },
        { value: 'COMPLETED', label: 'POR VALIDAR' },
        { value: 'ACCEPTED', label: 'POR PAGAR' },
        { value: 'REJECTED', label: 'RECHAZADA' },
        { value: 'PAID', label: 'PAGADA' }
      ]
    }
  },
  methods: {
    initializeWeekOptions () {
      const options = [];
      const now = new Date();

      const currentWeekStart = this.getStartOfWeek(now);
      const currentWeekEnd = this.getEndOfWeek(currentWeekStart);

      const currentFortnight = this.getCurrentFortnightRange(now);

      const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      const currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      const previousWeekStart = new Date(currentWeekStart);
      previousWeekStart.setDate(previousWeekStart.getDate() - 7);
      const previousWeekEnd = this.getEndOfWeek(previousWeekStart);

      const previousFortnight = this.getPreviousFortnightRange(now);

      const previousMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const previousMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);

      options.push({
        value: this.formatDateIso(currentWeekStart) + '|' + this.formatDateIso(currentWeekEnd),
        label: 'SEMANA ACTUAL (' + this.formatDateLabel(currentWeekStart) + ' - ' + this.formatDateLabel(currentWeekEnd) + ')'
      });

      options.push({
        value: this.formatDateIso(currentFortnight.start) + '|' + this.formatDateIso(currentFortnight.end),
        label: 'QUINCENA ACTUAL (' + this.formatDateLabel(currentFortnight.start) + ' - ' + this.formatDateLabel(currentFortnight.end) + ')'
      });

      options.push({
        value: this.formatDateIso(currentMonthStart) + '|' + this.formatDateIso(currentMonthEnd),
        label: 'MES ACTUAL (' + this.formatDateLabel(currentMonthStart) + ' - ' + this.formatDateLabel(currentMonthEnd) + ')'
      });

      options.push({
        value: this.formatDateIso(previousWeekStart) + '|' + this.formatDateIso(previousWeekEnd),
        label: 'SEMANA ANTERIOR (' + this.formatDateLabel(previousWeekStart) + ' - ' + this.formatDateLabel(previousWeekEnd) + ')'
      });

      options.push({
        value: this.formatDateIso(previousFortnight.start) + '|' + this.formatDateIso(previousFortnight.end),
        label: 'QUINCENA ANTERIOR (' + this.formatDateLabel(previousFortnight.start) + ' - ' + this.formatDateLabel(previousFortnight.end) + ')'
      });

      options.push({
        value: this.formatDateIso(previousMonthStart) + '|' + this.formatDateIso(previousMonthEnd),
        label: 'MES ANTERIOR (' + this.formatDateLabel(previousMonthStart) + ' - ' + this.formatDateLabel(previousMonthEnd) + ')'
      });

      this.weekOptions = options;
      this.weekSelect = options.length > 0 ? options[0].value : "";
    },
    getStartOfWeek(date) {
      const value = new Date(date);
      const day = value.getDay();
      const diff = day === 0 ? -6 : 1 - day;

      value.setDate(value.getDate() + diff);
      value.setHours(0, 0, 0, 0);

      return value;
    },
    getEndOfWeek(date) {
      const value = new Date(date);

      value.setDate(value.getDate() + 6);
      value.setHours(0, 0, 0, 0);

      return value;
    },
    getCurrentFortnightRange(date) {
      const year = date.getFullYear();
      const month = date.getMonth();

      if(date.getDate() <= 15){
        return {
          start: new Date(year, month, 1),
          end: new Date(year, month, 15)
        };
      }

      return {
        start: new Date(year, month, 16),
        end: new Date(year, month + 1, 0)
      };
    },
    getPreviousFortnightRange(date) {
      const year = date.getFullYear();
      const month = date.getMonth();

      if(date.getDate() <= 15){
        return {
          start: new Date(year, month - 1, 16),
          end: new Date(year, month, 0)
        };
      }

      return {
        start: new Date(year, month, 1),
        end: new Date(year, month, 15)
      };
    },
    formatDateIso (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return year + '-' + month + '-' + day;
    },
    formatDateLabel (date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return day + '/' + month + '/' + year;
    },
    async changeFilters (page) {
      this.loading();
        this.tab == "locked" ? this.dateSelect = this.dateSelect : this.dateSelect = "CURRENT";

        let week_start = "";
        let week_end = "";

        if(this.weekSelect){
          let week_range = this.weekSelect.split('|');
          week_start = week_range[0] ? week_range[0] : "";
          week_end = week_range[1] ? week_range[1] : "";
        }

        let filters = {
          region: this.regionSelect,
          customer: this.customerSelect,
          freelancer: this.freelancerSelect,
          current: this.dateSelect,
          week_start: week_start,
          week_end: week_end,
          tab: this.tab,
          page: page
        };
        
        let response = await ws.getFreelanceVisits(filters);

        if(response.type == "success"){
          this.customers = response.customers;        
          this.freelancers = response.freelancers;        
          this.total = response.total;

          const r = response.paginate;

          this.items = r.data;

          this.pagination.current = r.current_page
          this.pagination.last = r.last_page
          this.pagination.perPage = r.per_page
          this.pagination.total = r.total
          this.pagination.next = r.next_page_url
          this.pagination.prev = r.prev_page_url

          this.customerOptions = [{"label": "TODAS LAS MARCAS","value":"TODAS"}];
          this.freelancerOptions = [{"label": "TODOS LOS PROMOTORES","value":"TODOS"}];

          if(this.customers && this.customers.length > 0){
            this.customerOptions = await this.$parseSelectOptions(this.customers, "id", "name", this.customerOptions);
          }

          if(this.freelancers && this.freelancers.length > 0){
            this.freelancerOptions = await this.$parseSelectOptions(this.freelancers, "id", "name", this.freelancerOptions);
          }

          if(!this.customerOptions.some(option => String(option.value) == String(this.customerSelect))){
            this.customerSelect = "TODAS";
          }

          if(!this.freelancerOptions.some(option => String(option.value) == String(this.freelancerSelect))){
            this.freelancerSelect = "TODOS";
          }
        }
      this.loaded();
    },
    async block (item) {
      this.loading();

        let response = await ws.blockVisit(item.id);

        this.showToast(response.type, response.message);
        
      this.loaded();

      await this.changeFilters(1);
    },
    async unblock (item) {
      this.loading();        

        let response = await ws.unblockVisit(item.id);

        this.showToast(response.type, response.message);
        
      this.loaded();

      await this.changeFilters(1);
    },
    async complete (item) {
      this.loading();        

        let response = await ws.completeVisit(item.id);

        this.showToast(response.type, response.message);
        
      this.loaded();

      await this.changeFilters(1);
    },
    async deleteVisit (item) {
      this.loading();        

        let response = await ws.deleteVisit(item.id);

        this.showToast(response.type, response.message);
        
      this.loaded();

      await this.changeFilters(1);
    },
    async showVisitModal (item) {
      this.$refs.visitShowModal.showVisitModal(item);
    },
    assignFreelancerModal (item) {
      this.selectedVisitToAssign = item;
      this.assignFreelancerId = '';
      this.showAssignFreelancerModal = true;
    },
    closeAssignFreelancerModal () {
      this.showAssignFreelancerModal = false;
      this.selectedVisitToAssign = null;
      this.assignFreelancerId = '';
    },
    rectifyVisitModal (item) {
      this.selectedVisitToRectify = item;
      this.rectifyStatus = item && item.status ? item.status : '';
      this.showRectifyStatusModal = true;
    },
    closeRectifyStatusModal () {
      this.showRectifyStatusModal = false;
      this.selectedVisitToRectify = null;
      this.rectifyStatus = '';
    },
    async confirmAssignFreelancer () {
      if(!this.selectedVisitToAssign || !this.selectedVisitToAssign.id){
        this.showToast('error', 'No se encontró la visita seleccionada.');
        return;
      }

      if(!this.assignFreelancerId){
        this.showToast('warning', 'Debes seleccionar un promotor.');
        return;
      }

      this.loading();

      let response = await ws.assignVisit({
        id: this.selectedVisitToAssign.id,
        freelancer_id: this.assignFreelancerId
      });

      this.closeAssignFreelancerModal();

      if(response.type == 'success'){
        this.showToast('success', 'La visita se asigno correctamente.');
      }
      else{
        this.showToast('error', response.message);
      }

      this.loaded();

      await this.changeFilters(1);
    },
    async confirmRectifyStatus () {
      if(!this.selectedVisitToRectify || !this.selectedVisitToRectify.id){
        this.showToast('error', 'No se encontró la visita seleccionada.');
        return;
      }

      if(!this.rectifyStatus){
        this.showToast('warning', 'Debes seleccionar un estatus.');
        return;
      }

      this.loading();

      let response = await ws.rectifyVisit({
        id: this.selectedVisitToRectify.id,
        status: this.rectifyStatus
      });

      this.closeRectifyStatusModal();

      if(response.type == 'success'){
        this.showToast('success', 'La visita se rectifico correctamente.');
      }
      else{
        this.showToast('error', response.message);
      }

      this.loaded();

      await this.changeFilters(1);
    },
    async validateModal (item) {
      this.$refs.visitValidationModal.showVisitModal(item);
    },
    async rejectModal (item) {
      this.$refs.visitRejectModal.showVisitModal(item);
    },
    async releaseRejectedModal (item) {
      this.$refs.releaseRejectedVisitModal.showVisitModal(item);
    },
    async changeDateModal (item) {
      if(!this.canChangeVisitFields){
        return;
      }

      this.$refs.changeVisitDateModal.showVisitModal(item);
    },
    async changeBudgetModal (item) {
      if(!this.canChangeVisitFields){
        return;
      }

      this.$refs.changeVisitBudgetModal.showVisitModal(item);
    },
    async payModal () {
      let filters = this.buildFilters();
      
      let response = await ws.getTotalFreelanceVisits(filters);

      let payments = [];
      if(response.type == "success"){
          payments = response.payments;
      }

      this.$refs.paymentVisitsModal.showPaymentModal(payments);
    },
    async exportVisits () {
      this.loading();

      try {
        const filters = this.buildFilters();
        let allItems = [];
        let page = 1;
        let lastPage = 1;

        console.log('[FreelanceVisits] Export filters:', filters);

        do {
          const response = await ws.getFreelanceVisits({ ...filters, page });

          if(response.type != 'success'){
            this.showToast(response.type, response.message);
            return;
          }

          const paginate = response.paginate || {};
          const data = paginate.data || [];

          allItems = allItems.concat(data);
          lastPage = paginate.last_page || 1;
          page += 1;
        } while (page <= lastPage);

        console.log('[FreelanceVisits] Export rows:', allItems.length);

        if(allItems.length == 0){
          this.showToast('warning', 'No hay registros para exportar con los filtros seleccionados.');
          return;
        }

        const csv = this.buildCsvFromVisits(allItems);
        const blob = new Blob(["\uFEFF" + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = this.getExportFileName();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.showToast('success', 'Archivo generado correctamente.');
      }
      finally {
        this.loaded();
      }

      await this.changeFilters(this.pagination.current || 1);
    },
    async exportCompletedAndRejectedVisits () {
      this.loading();

      try {
        const baseFilters = this.buildFilters();
        this.startExportProgress('Iniciando exportacion', 'Preparando filtros para completadas y rechazadas...', 5);
        console.log('[FreelanceVisits] Combined export base filters:', baseFilters);

        const completedItems = await this.fetchAllVisitsForTab(baseFilters, 'completed', 'completadas', 10, 50);
        const rejectedItems = await this.fetchAllVisitsForTab(baseFilters, 'rejected', 'rechazadas', 55, 90);

        console.log('[FreelanceVisits] Combined export rows completed:', completedItems.length);
        console.log('[FreelanceVisits] Combined export rows rejected:', rejectedItems.length);

        if(completedItems.length == 0 && rejectedItems.length == 0){
          this.stopExportProgress();
          this.showToast('warning', 'No hay visitas completadas ni rechazadas para exportar con los filtros seleccionados.');
          return;
        }

        this.updateExportProgress('Construyendo archivo', 'Separando tablas de completadas y rechazadas...', 95);
        const csv = this.buildCombinedCsvFromVisits(completedItems, rejectedItems);
        const blob = new Blob(["\uFEFF" + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = this.getExportFileName('completadas_rechazadas');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.stopExportProgress();
        this.showToast('success', 'Archivo generado correctamente: visitas completadas y rechazadas.');
      }
      catch (error) {
        this.stopExportProgress();
        const message = error && error.message ? error.message : 'Ocurrio un error al exportar visitas completadas y rechazadas.';
        this.showToast('error', message);
      }
      finally {
        this.loaded();
      }

      await this.changeFilters(this.pagination.current || 1);
    },
    async fetchAllVisitsForTab (baseFilters, tab, label, startPercent, endPercent) {
      let allItems = [];
      let page = 1;
      let lastPage = 1;

      this.updateExportProgress('Obteniendo visitas ' + label, 'Consultando pagina 1...', startPercent);

      do {
        const filters = {
          ...baseFilters,
          tab: tab,
          page: page
        };

        const response = await ws.getFreelanceVisits(filters);

        if(response.type != 'success'){
          throw new Error(response.message || ('No fue posible obtener visitas ' + label + '.'));
        }

        const paginate = response.paginate || {};
        const data = paginate.data || [];

        allItems = allItems.concat(data);
        lastPage = paginate.last_page || 1;

        const progress = lastPage > 0
          ? startPercent + Math.floor((page / lastPage) * (endPercent - startPercent))
          : endPercent;
        this.updateExportProgress('Obteniendo visitas ' + label, 'Pagina ' + page + ' de ' + lastPage + '.', progress);
        console.log('[FreelanceVisits] Export ' + label + ' page ' + page + '/' + lastPage + ' rows:', data.length);

        page += 1;
      } while (page <= lastPage);

      return allItems;
    },
    startExportProgress (title, detail, percent) {
      this.showExportProgressModal = true;
      this.exportProgressTitle = title;
      this.exportProgressDetail = detail;
      this.exportProgressPercent = percent || 0;
    },
    updateExportProgress (title, detail, percent) {
      this.exportProgressTitle = title;
      this.exportProgressDetail = detail;
      this.exportProgressPercent = Math.max(0, Math.min(100, percent || 0));
    },
    stopExportProgress () {
      this.showExportProgressModal = false;
      this.exportProgressTitle = '';
      this.exportProgressDetail = '';
      this.exportProgressPercent = 0;
    },
    buildFilters () {
      let week_start = "";
      let week_end = "";

      if(this.weekSelect){
        let week_range = this.weekSelect.split('|');
        week_start = week_range[0] ? week_range[0] : "";
        week_end = week_range[1] ? week_range[1] : "";
      }

      return {
        region: this.regionSelect,
        customer: this.customerSelect,
        freelancer: this.freelancerSelect,
        week_start: week_start,
        week_end: week_end,
        tab: this.tab
      };
    },
    buildCsvFromVisits (items) {
      const headers = [
        'No.',
        'Dia de Visita',
        'Marca',
        'Cadena',
        'Sucursal',
        'Zona',
        'Monto a Pagar',
        'Promotor',
        'Status'
      ];

      const rows = items.map(item => {
        return [
          item.id || '',
          this.formatCsvDate(item.date),
          item.customer_name || '',
          item.store_name || '',
          item.branch_name || '',
          item.state || '',
          item.budget != null ? item.budget : '',
          item.freelancer_name || 'NO DEFINIDO',
          this.getStatusLabel(item.status)
        ];
      });

      return [headers, ...rows]
        .map(row => row.map(value => this.escapeCsvValue(value)).join(','))
        .join('\n');
    },
    buildCombinedCsvFromVisits (completedItems, rejectedItems) {
      const completedRows = this.buildCsvRowsFromVisits(completedItems);
      const rejectedRows = this.buildCsvRowsFromVisits(rejectedItems);

      const completedTable = [
        ['VISITAS COMPLETADAS'],
        ...completedRows
      ];

      const rejectedTable = [
        ['VISITAS RECHAZADAS'],
        ...rejectedRows
      ];

      return [...completedTable, [''], [''], ...rejectedTable]
        .map(row => row.map(value => this.escapeCsvValue(value)).join(','))
        .join('\n');
    },
    buildCsvRowsFromVisits (items) {
      const headers = [
        'No.',
        'Dia de Visita',
        'Marca',
        'Cadena',
        'Sucursal',
        'Zona',
        'Monto a Pagar',
        'Promotor',
        'Status'
      ];

      const rows = items.map(item => {
        return [
          item.id || '',
          this.formatCsvDate(item.date),
          item.customer_name || '',
          item.store_name || '',
          item.branch_name || '',
          item.state || '',
          item.budget != null ? item.budget : '',
          item.freelancer_name || 'NO DEFINIDO',
          this.getStatusLabel(item.status)
        ];
      });

      return [headers, ...rows];
    },
    formatCsvDate (value) {
      if(!value){
        return '';
      }

      const date = new Date(value);
      if(isNaN(date.getTime())){
        return String(value);
      }

      return this.formatDateLabel(date);
    },
    getStatusLabel (status) {
      if(status == 'AVAILABLE') return 'DISPONIBLE';
      if(status == 'LOCKED') return 'EN CURSO';
      if(status == 'COMPLETED') return 'POR VALIDAR';
      if(status == 'ACCEPTED') return 'POR PAGAR';
      if(status == 'REJECTED') return 'RECHAZADA';
      if(status == 'PAID') return 'PAGADA';
      return 'ARCHIVADA';
    },
    escapeCsvValue (value) {
      const normalized = value == null ? '' : String(value);
      const escaped = normalized.replace(/"/g, '""');

      return `"${escaped}"`;
    },
    getExportFileName (tabLabel) {
      const label = tabLabel ? tabLabel.toLowerCase() : (this.tab ? this.tab.toLowerCase() : 'visitas');
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      const h = String(now.getHours()).padStart(2, '0');
      const min = String(now.getMinutes()).padStart(2, '0');

      return `visitas_${label}_${y}${m}${d}_${h}${min}.csv`;
    },
    async reactive (item) {
      this.loading();        

        let response = await ws.reactiveVisit(item.id);

        this.showToast(response.type, response.message)
        
      this.loaded();

      await this.changeFilters(1);
    },
    async archive (item) {
      this.loading();        

        let response = await ws.archiveVisit(item.id);

        this.showToast(response.type, response.message)
        
      this.loaded();

      await this.changeFilters(1);
    },
    async refreshItems(){
        await this.changeFilters(1);
    },
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'danger'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'success'
      }
      return $color
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style>
.warning{
 background-color: #F9B115;
}
.success{
  background-color: #1B9E3E;
}
.danger{
  background-color: #E55353
}
.other{
  background-color: #6b7785
}
.card.success{
  color:black !important;
  font-weight: bold !important;
}
.card-header-actions select{
  font-size: 12px;
}
.card-header{
  font-size: 20px;
  padding: 10px 15px 10px 20px;

}
</style>
